export const imgUrl = 'https://lockan.obs.cn-east-3.myhuaweicloud.com/'

// 手机号校验
export function checkPhoneNumber(rule, value, callback) {
  const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/ //11位手机号
  if (!value) {
    return callback(new Error('号码不能为空'))
  } else if (!reg.test(value)) {
    return callback(new Error('号码格式不正确'))
  } else {
    return callback()
  }
}
